export default __webpack_public_path__ + "static/PSALogoWhite-6c7ac4d2bcad9f473a34b4ebc55679bd.svg";